export const hidePhoneNumber = (phoneNumber:string) => {
  if (phoneNumber) {
    //   ===  add 0 to start phoneNumber ===
    if (!phoneNumber?.startsWith("0")) {
      phoneNumber = "0" + phoneNumber;
    }
    let _hidePhoneNumber: any = phoneNumber.match(/(\d{4})(\d{4})(\d{3})/);
    _hidePhoneNumber = _hidePhoneNumber[1] + " **** " + _hidePhoneNumber[3];
    return _hidePhoneNumber || phoneNumber;
  }
  return null;
};
